module.exports = __webpack_public_path__ + "img/horizontal_4_6_7042.c4d27e18.png";